import { BehaviorSubject } from 'rxjs';

const subjectList = new BehaviorSubject({});

const ListStore = {
  update: (listName, productId) => {
    subjectList.next({ list: listName, product: productId });
  },

  subscribe: setState => subjectList.subscribe(setState),

  getValue: () => subjectList.value,

  getProductId: () => subjectList.value.product, // Retrieve only the product ID

  getListName: () => subjectList.value.list, // Retrieve only the list name
};

export default ListStore;
